import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de.json';
import en from './locales/en.json';
import tr from './locales/tr.json';
import pl from './locales/pl.json';
import fr from './locales/fr.json';
import cs from './locales/cs.json';
import es from './locales/es.json';
import it from './locales/it.json';
import ro from './locales/ro.json';
import hu from './locales/hu.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      tr: { translation: tr },
      pl: { translation: pl },
      fr: { translation: fr },
      cs: { translation: cs },
      es: { translation: es },
      it: { translation: it },
      ro: { translation: ro },
      hu: { translation: hu },
    },
    fallbackLng: 'de',
    lng: localStorage.getItem('qm8d_language') || 'de',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'qm8d_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
